import cx from "classnames";

import Icon from "@ide/shared/components/Icon";

const CheckBox = ({ name, checked = false, onChange = () => {}, className = "" }) => {
  // return null;

  return (
    <div className={cx("cursor-pointer w-6 h-6 relative overflow-hidden group", className)}>
      <input
        type="checkbox"
        className="absolute left-1/2 -translate-x-1/2 w-full h-full peer appearance-none hidden"
        name={name}
        checked={checked}
        onChange={onChange}
      />

      <span
        className={
          "flex justify-center items-center w-6 h-6 border-3 rounded-sm transition-all duration-100 peer-checked:bg-black/90 peer-checked:border-black/90"
        }
      >
        <Icon icon="fa-solid fa-check" className="w-3 h-3 p-2 text-white" />
      </span>
    </div>
  );
};

export default CheckBox;
